import { ChangeEvent, useState } from 'react';
// import hasSequentialNumbers from '../../../../utils/hasSequentialNumbers';
import useErrors from '../../../../hooks/useErrors';
import formatCpf from '../../../../utils/formatCpf';
import isCpfvalid from '../../../../utils/isCpfValid';
import isEmailValid from '../../../../utils/isEmailValid';

export default function useInputChanges() {
  const [loginType, setLoginType] = useState('cpf');
  const [login, setLogin] = useState('');
  const [cpf, setCpf] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const {
    setError, removeError, getErrorMessageByFieldName, errors,
  } = useErrors();

  function handleLoginChange(event: ChangeEvent<HTMLInputElement>) {
    if (!event.target.value) {
      setError({ field: 'username', message: 'Informe um nome de usuário' });
    } else {
      removeError('username');
    }
    setLogin(event.target.value);
  }

  function handlePasswordChange(event: ChangeEvent<HTMLInputElement>) {
    setPassword(event.target.value);
    if (!event.target.value.length) {
      setError({
        field: 'password', message: 'Insira uma senha!',
      });
    }
    // else if (hasSequentialNumbers(event.target.value)) {
    //   setError({ field: 'password', message: 'A senha não pode conter números sequenciais!' });
    // }
    else if (event.target.value.length < 8) {
      setError({ field: 'password', message: 'Senhe deve conter no mínimo 8 caracteres!' });
    } else {
      removeError('password');
    }
  }

  function handleCpfChange(event: ChangeEvent<HTMLInputElement>) {
    setCpf(formatCpf(event.target.value));
    if (!event.target.value || !isCpfvalid(formatCpf(event.target.value))) {
      setError({ field: 'cpf', message: 'Informe um cpf válido!' });
    } else {
      removeError('cpf');
    }
  }

  function handleEmailChange(event: ChangeEvent<HTMLInputElement>) {
    setEmail(event.target.value);
    if (!event.target.value || !isEmailValid(event.target.value)) {
      setError({ field: 'email', message: 'Informe um e-mail válido!' });
    } else {
      removeError('email');
    }
  }

  function handleLoginTypeChange(value: string) {
    setLoginType(value);
    setLogin('');
    setCpf('');
    setEmail('');
    removeError('cpf');
    removeError('email');
    removeError('username');
  }

  return {
    loginType,
    login,
    cpf,
    email,
    password,
    getErrorMessageByFieldName,
    errors,
    handleLoginChange,
    handlePasswordChange,
    handleCpfChange,
    handleEmailChange,
    handleLoginTypeChange,
    setLogin,
    setPassword,
    removeError,
    setLoginType,
    setCpf,
    setEmail,
  };
}
